import { InfiniteScroll } from 'element-ui'

const YInfiniteScroll = InfiniteScroll
YInfiniteScroll.$depends = [InfiniteScroll]
YInfiniteScroll.$name = 'y-infinite-scroll'
YInfiniteScroll._name = 'InfiniteScroll 无限滚动'

export default YInfiniteScroll
